module.exports = __webpack_public_path__ + "media/1x1/bs-6fe877e1.svg";